import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, immediate = false, className = "" }) => {
  const inner = (
    <motion.span
      className="block will-change-transform"
      initial={{ y: "110%" }}
      {...(immediate
        ? { animate: { y: "0%" } }
        : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-8%" } })}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  );
  return <span className={`block overflow-hidden ${className}`}>{inner}</span>;
};

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", dark = false }) => (
  <p
    className={`font-mono text-[11px] sm:text-xs tracking-[0.25em] uppercase ${
      dark ? "text-paper/50" : "text-ink/50"
    } ${className}`}
  >
    {children}
  </p>
);
